import React from "react";
import { json2csv } from "json-2-csv";
import InstructorSidebar from "../common/instructorSidebar";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import { useUserList } from "./hooks/useUsers";
import { getUsers, User, UserListResponse } from "../../../api/user";


const UserList = () => {
  const { data, isLoading, page, limit, search, setSearch, onPaginationChange } = useUserList({});
  const users = data?.data ?? [];
  const total = data?.total ?? 0;
  

  const columns = [
    {
      title: "No",
      dataIndex: "id",
      render: (id: number) => (
        <Link to={`${all_routes.adminUser}/${id}`} className="text-primary">
          {id}
        </Link>
      ),
    },
    {
      title: "Name",
      dataIndex: "fullname",
      render: (text: string, record: any) => (
        <Link to={`${all_routes.adminUser}/${record.id}`}>
          <p className="fs-14 mb-0">{text}</p>
        </Link>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "No. HP",
      dataIndex: "phone_number",
    },
    {
      title: "Role",
      dataIndex: "role",
    },
    {
      title: "Action",
      dataIndex: "id",
      render: (id: number) => (
        <div className="d-flex align-items-center">
          <Link
            to={`${all_routes.adminUser}/${id}`}
            className="d-inline-flex fs-14 me-1 action-icon"
          >
            <i className="isax isax-eye" />
          </Link>
          <Link
            to={`${all_routes.adminUser}/edit/${id}`}
            className="d-inline-flex fs-14 action-icon"
          >
            <i className="isax isax-edit" />
          </Link>
        </div>
      ),
    },
  ];

  const handleDownloadCsv = async () => {
    try {
      // 1️⃣ Fetch user data (with export flag)
      const res = await getUsers({ export: true }, true);

      // 2️⃣ Normalize data (in case API returns paginated or direct array)
      const getUsersData: User[] = Array.isArray(res)
        ? res
        : ((res as UserListResponse)?.data ?? []);

      // 3️⃣ Map to CSV-friendly format
      const csvData = getUsersData.map((user: any) => ({
        Nama: user.fullname || "-",
        Email: user.email || "-",
        "No HP": user.phone_number || "-",
        NIK: user.nik || "-",
        "Jenis Kelamin":
          user.gender === "male"
            ? "Laki-laki"
            : user.gender === "female"
              ? "Perempuan"
              : "-",
        Alamat: user.address || "-",
      }));

      // 4️⃣ Convert JSON → CSV
      const csv = await json2csv(csvData);

      // 5️⃣ Trigger CSV download
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `users-${new Date().toLocaleDateString("id-ID")}.csv`;
      document.body.appendChild(link);
      link.click();

      // cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Error generating CSV:", error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <InstructorSidebar />
            {/* /Sidebar */}
            <div className="col-lg-9">
              <div className="page-title d-flex align-items-center justify-content-between">
                <h5 className="fw-bold">Users</h5>

                <div className="d-flex align-items-center justify-content-end">
                  <Link
                    to="#"
                    className="btn btn-primary rounded-pill ms-3"
                    onClick={() => handleDownloadCsv()}
                  >
                    <i className="isax isax-add-circle me-2 fs-10" />
                    Download CSV
                  </Link>
                  <Link
                    to="/admin/user/add"
                    className="btn btn-secondary rounded-pill ms-3"
                  >
                    <i className="isax isax-add-circle me-2 fs-10" />
                    Add User
                  </Link>
                </div>
              </div>
              <div className="row justify-content-end">
                <div className="col-md-4">
                  <div className="input-icon mb-3">
                    <span className="input-icon-addon">
                      <i className="isax isax-search-normal-14" />
                    </span>
                    <input
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search..."
                      className="form-control form-control-md"
                    />
                  </div>
                </div>
              </div>
              <Table
                columns={columns}
                dataSource={users}
                isLoading={isLoading}
                pagination={{
                  current: page,
                  pageSize: limit,
                  total: total,
                  last_page: data?.last_page,
                }}
                onChange={onPaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserList;
